'use client';

import { createContext } from 'react';

import type { DrawerRootContextInterface } from '../types/drawer-root.types';

export const DrawerRootContext = createContext({} as DrawerRootContextInterface);

DrawerRootContext.displayName = 'Drawer.Root.Context';
